// Calc the relative brightness of RGB color, normalized to 0 for darkest black and 1 for lightest white
// according to relative luminance formula (https://www.w3.org/TR/WCAG21/#dfn-relative-luminance)
const luminance = (color) => {
    const { r, g, b, a } = color;
    let [lumR, lumG, lumB] = [r, g, b].map(RGBColorKey => {
        let proportion = applyAlpha(RGBColorKey, a !== null && a !== void 0 ? a : 1) / 255;
        return proportion <= 0.03928
            ? proportion / 12.92
            : Math.pow((proportion + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lumR + 0.7152 * lumG + 0.0722 * lumB;
};
const applyAlpha = (color, opacity) => 255 - opacity * (255 - color);
// Construct ratio according to formula (https://www.w3.org/TR/WCAG21/#dfn-contrast-ratio)
const contrastRatio = (luminance1, luminance2) => {
    let lighterLum = Math.max(luminance1, luminance2);
    let darkerLum = Math.min(luminance1, luminance2);
    return (lighterLum + 0.05) / (darkerLum + 0.05);
};
// Returns a value between 1-21 where higher value represtents strong contrast
export const checkContrast = (color1, color2) => {
    let [luminance1, luminance2] = [color1, color2].map(color => {
        let r;
        let g;
        let b;
        let a;
        if (color === "transparent") {
            r = parseInt("255");
            g = parseInt("255");
            b = parseInt("255");
        }
        if (color.includes("rgba")) {
            const values = color.substring(5, color.length - 1).split(",");
            r = parseInt(values[0]);
            g = parseInt(values[1]);
            b = parseInt(values[2]);
            a = parseInt(values[3]);
        }
        else if (color.includes("rgb")) {
            const values = color.substring(4, color.length - 1).split(",");
            r = parseInt(values[0]);
            g = parseInt(values[1]);
            b = parseInt(values[2]);
        }
        else if (color.length <= 9) {
            return luminance(hexToRGBColor(color));
        }
        return luminance({ r, g, b, a });
    });
    return contrastRatio(luminance1, luminance2);
};
export const hexToRGBColor = (color) => {
    const value = color.startsWith("#") ? color.slice(1) : color;
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    const a = value.length > 6 ? parseInt(value.slice(6, 8), 16) / 255 : undefined;
    return { r, g, b, a };
};
export const colorStateToRgbaString = (color) => (color.hex === "transparent"
    ? color.hex
    : (`rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b}`
        + (color.rgb.a === undefined
            ? ""
            : `,${color.rgb.a}`)
        + ")"));
export const isSameColor = (color1, color2) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return (((_a = color1 === null || color1 === void 0 ? void 0 : color1.rgb) === null || _a === void 0 ? void 0 : _a.r) === ((_b = color2 === null || color2 === void 0 ? void 0 : color2.rgb) === null || _b === void 0 ? void 0 : _b.r)
        && ((_c = color1 === null || color1 === void 0 ? void 0 : color1.rgb) === null || _c === void 0 ? void 0 : _c.g) === ((_d = color2 === null || color2 === void 0 ? void 0 : color2.rgb) === null || _d === void 0 ? void 0 : _d.g)
        && ((_e = color1 === null || color1 === void 0 ? void 0 : color1.rgb) === null || _e === void 0 ? void 0 : _e.b) === ((_f = color2 === null || color2 === void 0 ? void 0 : color2.rgb) === null || _f === void 0 ? void 0 : _f.b)
        && ((_g = color1 === null || color1 === void 0 ? void 0 : color1.rgb) === null || _g === void 0 ? void 0 : _g.a) === ((_h = color2 === null || color2 === void 0 ? void 0 : color2.rgb) === null || _h === void 0 ? void 0 : _h.a));
};
/**
 * Convert `ColorState` object to a hex representation.
 * Should be used instead of `color.hex` because `react-color` doesn't support
 * representing alpha channel in a hex format.
 */
export const colorStateToHexString = (color) => (color.rgb.a !== undefined && color.rgb.a > 0
    ? color.hex + Math.round(color.rgb.a * 255).toString(16).padStart(2, "0")
    : color.hex);
//# sourceMappingURL=utils.js.map